import { render, staticRenderFns } from "./Workers.vue?vue&type=template&id=7b47a0ae&scoped=true"
import script from "./Workers.vue?vue&type=script&lang=js"
export * from "./Workers.vue?vue&type=script&lang=js"
import style0 from "./Workers.vue?vue&type=style&index=0&id=7b47a0ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b47a0ae",
  null
  
)

export default component.exports